<template>
  <div id="app">
    <!-- 分析结果模态框 -->
    <AnalysisResultModal 
      :isVisible="displayResultModal"
      @close="hideResultModal"
      @showLineConfirm="redirectToLine"
    />

    <!-- 顶部导航区域 -->
    <HeaderNavigation />

    <!-- 核心内容区域 -->
    <CoreContentSection @startAnalysis="initiateAnalysis" />

    <!-- 底部信息区域 -->
    <FooterInformation />
  </div>
</template>

<script>
import HeaderNavigation from './components/HeaderNavigation.vue'
import CoreContentSection from './components/CoreContentSection.vue'
import FooterInformation from './components/FooterInformation.vue'
import AnalysisResultModal from './components/AnalysisResultModal.vue'

export default {
  name: 'ApplicationRoot',
  components: {
    HeaderNavigation,
    CoreContentSection,
    FooterInformation,
    AnalysisResultModal
  },
  data() {
    return {
      displayResultModal: false
    }
  },
  methods: {
    initiateAnalysis() {
      this.displayResultModal = true
    },
    hideResultModal() {
      this.displayResultModal = false
    },
    redirectToLine() {
      // 触发谷歌广告转换跟踪
      gtag('event', 'conversion', {
        'send_to': 'AW-17095578120/a5NbCOmI__MaEIik59c_'
      });
      gtag('event', 'Add', {
        'event_category': 'engagement',
        'event_label': 'conversion',
        'value': 1
      });

      // 跳转到联系页面
      window.location.href = '/contact.html';
    }
  }
}
</script>

<style>
/* 全局样式变量定义 */
:root {
  --brand-primary: #0062ff;
  --brand-secondary: #00e0ff;
  --brand-accent: #ff3e7f;
  --bg-dark-theme: #001638;
  --bg-medium-theme: #003366;
  --text-main: #ffffff;
  --text-sub: #b0c4de;
}

body, html {
  margin: 0;
  padding: 0;
  font-family: 'Noto Sans JP', sans-serif;
  box-sizing: border-box;
}

body {
  background-color: var(--bg-dark-theme);
  color: var(--text-main);
  line-height: 1.6;
  overflow-x: hidden;
  background-image: 
    radial-gradient(circle at 15% 30%, rgba(0, 98, 255, 0.15) 0%, transparent 35%),
    radial-gradient(circle at 80% 70%, rgba(0, 224, 255, 0.1) 0%, transparent 45%);
}

* {
  box-sizing: border-box;
}
</style> 